/** @jsx h */
import { h } from 'preact'
import DatePicker from './date'
import { useState, useRef } from 'preact/compat'
import Icon from './icons/icons'
import clsx from 'clsx'
import useClickOutside from '../use-click-outside'
import dayjs from 'dayjs'

const InputDate = ({
  id,
  onChange,
  label,
  required = false,
  name,
  value,
  availabilities,
  hasError,
  direction,
  isExternalPointOfSale,
  placeholder
}) => {
  const [toggled, toggle] = useState(false)
  const ref = useRef()

  useClickOutside(ref, () => {
    toggle(false)
  })

  const dateFormat = date => {
    if (dayjs.locale() === 'ko') {
      return dayjs(date).format('LL')
    }

    if (dayjs.locale() === 'ar') {
      return dayjs(date).format('DD/MM/YYYY')
    }

    return dayjs(date).format('L')
  }

  return (
    <div ref={ref} className={`rcc_c_input-date-component rcc_c_with-icon`}>
      <label
        htmlFor={id}
        className={clsx('rcc-text-sm rcc-block rcc-mb-2.5', {
          'rcc-text-gray': !hasError,
          'rcc-text-danger': hasError,
          'rcc-text-right': direction === 'rtl'
        })}
      >
        {label}
      </label>

      <div
        className={clsx('rcc-flex rcc-items-center rcc-border rcc-border-solid', {
          'rcc-border-danger': hasError,
          'rcc-border-gray-light': !hasError,
          'rcc-flex-row-reverse': direction === 'rtl'
        })}
      >
        <div
          className={clsx('rcc-self-stretch rcc-flex rcc-items-center rcc-px-4 rcc-border-r rcc-border-gray-light', {
            'rcc-border-l rcc-border-r-0': direction === 'rtl'
          })}
        >
          <Icon name='calendar' className='rcc_c_input-icon' />
        </div>
        <input
          id={id}
          onClick={() => toggle(prev => !prev)}
          className={clsx(
            'js-input-date rcc-placeholder-black rcc-text-text rcc-text-sm rcc-h-[50px] rcc-flex-1 rcc-pl-5 rcc-pr-8 rcc-bg-transparent rcc-cursor-pointer',
            {
              'rcc-text-right': direction === 'rtl',
              'rcc-text-left': direction === 'ltr'
            }
          )}
          type='button'
          value={value ? dateFormat(value) : placeholder}
          name={name}
          required={required}
          readOnly
          aria-label='Toggle calendar'
        ></input>
        <div
          className={clsx('rcc-flex rcc-items-center rcc-px-5 rcc-absolute rcc-h-[50px] rcc-right-0 rcc-z-[-1]', {
            'rcc-left-0 rcc-right-[unset]': direction === 'rtl'
          })}
        >
          <Icon name='arrow-next' className='rcc-pointer-events-none rcc-rotate-90' />
        </div>
      </div>
      <div
        className={clsx(
          'rcc_c_available-date js-container-available rcc-bg-white rcc-pointer-events-none rcc-border rcc-border-t-0 rcc-border-gray-light',
          {
            'rcc_c_is-open rcc-pointer-events-auto': toggled
          }
        )}
      >
        {toggled && (
          <DatePicker
            isExternalPointOfSale={isExternalPointOfSale}
            availabilities={availabilities}
            onChange={val => {
              onChange(val)
              toggle(false)
            }}
            value={value}
            isOpen={toggled}
          />
        )}
      </div>
    </div>
  )
}

export default InputDate
